import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

  constructor(private appService:AppService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let appendUrl:any = request.clone({url:this.appService.envVariable+request.url});
    return next.handle(appendUrl);
  }
}
